/**
 * Convert an absolute same-origin URL (e.g. from email/notification actionUrl)
 * into a React Router path. External URLs are returned unchanged.
 */
export function toSpaPath(urlOrPath: string | null | undefined): string | null {
  if (!urlOrPath) return null;
  const value = urlOrPath.trim();
  if (!value) return null;
  if (value.startsWith('/') && !value.startsWith('//')) {
    return value;
  }
  try {
    const url = new URL(value, typeof window !== 'undefined' ? window.location.origin : undefined);
    if (typeof window !== 'undefined' && url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
    return value;
  } catch {
    return value;
  }
}

/** Navigate in-app when possible; fall back to full page for external URLs. */
export function navigateAppPath(
  navigate: (to: string) => void,
  urlOrPath: string | null | undefined,
): boolean {
  const path = toSpaPath(urlOrPath);
  if (!path) return false;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('//')) {
    if (typeof window !== 'undefined') {
      window.location.assign(path);
      return true;
    }
    return false;
  }
  navigate(path);
  return true;
}
